import {
  shape, number, bool, string, arrayOf
} from '@thd-nucleus/data-sources';

const sweepstakesModel = shape({
  title: string(),
  image: string(),
  totalEntriesAvailable: number(),
  totalEntriesCompleted: number(),
  displaySweepStakeChallenge: bool(),
});

export const availablePerksCountModel = {
  availablePerks: number(),
  expiringPerks: number(),
  daysLeft: number(),
  availableOffers: number(),
  expiringOffers: number(),
  daysLeftForOffers: number(),
  isEnrolledInChallenges: bool(),
  challengeTitles: string(),
  // Note: sweepstakes field is intentionally excluded from validation
  // as it's optional in the API response and may not be present
  sweepstakes: arrayOf(sweepstakesModel),
};
